import type {RootStore} from 'stores/rootStore';
import type {HumanizerMode} from 'config';
import type {IUploadFileResponse} from 'requests';

/** The landing's explicit Humanize click uses the ordinary run/login continuation. */
export const acceptHumanizerHandoff = async (root: RootStore, text: string, mode: HumanizerMode | null, autorun: boolean) => {
    root.user.forceHumanizer(true);
    root.layout.setWorkspace('humanizer');
    if (mode) root.humanizer.setMode(mode);
    root.humanizer.setInputText(text);
    if (autorun) {
        await root.user.refresh();
        root.humanizer.runFromButton();
    }
};

/** Keep the shared-file metadata for a retry: the URL token has already been consumed. */
export const acceptHumanizerFilesHandoff = async (root: RootStore, files: IUploadFileResponse[], mode: HumanizerMode | null, autorun: boolean) => {
    root.user.forceHumanizer(true);
    root.layout.setWorkspace('humanizer');
    if (mode) root.humanizer.setMode(mode);
    const load = async (): Promise<void> => {
        const ready = await root.humanizer.loadSharedFiles(files, () => { void load(); });
        if (ready && autorun) {
            await root.user.refresh();
            root.humanizer.runFromButton();
        }
    };
    await load();
};
